import { LinkAnchor } from '../link/anchor';

/**
 * Model definition for InPage Navigation Opener
 */
export interface ContentInPageNavigationOpener {
  __component: 'content.in-page-navigation-opener';
  id: string;
  title: string;
  links: LinkAnchor[];
  variant: 'transparent' | 'white';
}

export function isContentInPageNavigationOpener(obj: { __component?: string }): obj is ContentInPageNavigationOpener {
  return obj.__component === 'content.in-page-navigation-opener';
}
